import { createSelector } from '../../dependencies';

const selectSuppliers = state => state.suppliers;

export const selectSupplierListFilter = createSelector(
    selectSuppliers,
    ({ filter }) => filter,
);
